<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "EICAD",
        icon: require("@/assets/images/digitalImg/eicad_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/eicad_icon.png"),
          title: "EICAD : Every road is a blueprint leading to the future.",
          subTitle: "Integrated Interactive Road and Interchange Design System",
          downloadBtnList: [
            {
              label: "Download For AutoCAD",
              fileUrl: "",
              fileName: "AutoCAD",
            },
            {
              label: "Download For ZWCAD",
              fileUrl: "",
              fileName: "ZWCAD",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_eicad.png"),
          videoUrl: `${prefix}/static/video/eicad_en.mp4`,
        },
        all: {
          title: "What is EICAD？",
          content:
            'EICAD is an independently developed interactive road and interchange design software by Delauney. It is primarily used for various stages of highway, municipal road, and interchange engineering design, including automatic drawing generation and project quantity estimation. EICAD encompasses a comprehensive range of functional modules, including field surveys, route and interchange design, roadbed and pavement, bridges and tunnels, traffic safety facilities, and drainage networks. Committed to the philosophy of "enhancing design efficiency and quality," EICAD continuously innovates, expands its functionality, and provides high-quality digital design solutions for infrastructure development.',
          imgLists: [
            {
              id: 1,
              title: "3D forward design, high quality（1/3）",
              img: require("@/assets/images/digitalImg/eicad_img1.png"),
            },
            {
              id: 2,
              title: "Data linkage, convenient modification（2/3） ",
              img: require("@/assets/images/digitalImg/eicad_img2.png"),
            },
            {
              id: 3,
              title: "Graphic interactive mode, connecting data links（3/3）",
              img: require("@/assets/images/digitalImg/eicad_img3.png"),
            },
          ],
        },
        highlights: {
          title: "Why Choose EICAD",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/eicad_icon3.png"),
              title: "1000+",
              content:
                "Assisted users in completing over 1,000 interchange designs in the past two years.",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/eicad_icon4.png"),
              title: "80%",
              content:
                "Trusted by over 1,000 design institutes, including 80% of top-tier institutes in the transportation and municipal sectors.",
            },
          ],
        },

        function: {
          title: "EICAD Functions！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/eicad_function01.png"),
              title:
                "Built-in Intelligent Entities for Integrated Horizontal, Vertical & Section Design – What You See Is What You Get",
              content:
                "The software supports massive digital terrain source data, including laser scans, DLG, and DEM, enabling the rapid creation of digital terrain models. In plan, profile, and cross-section designs, users can directly drag, double-click, and parametrically modify intelligent dynamic entities. Real-time linkage control ensures that changes are immediately reflected, helping designers efficiently complete road modeling, analysis, and design modifications.",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/eicad_function02.png"),
              title:
                "Comprehensive Multi-Disciplinary Coverage with Seamless Data Integration",
              content:
                "EICAD covers highways, municipal roads, rail transit, tunnels, bridges, traffic facilities, and drainage systems. Entity models and business data are shared in real time. When any parameter is modified, the changes are seamlessly transmitted across related modules, ensuring an automatically updated model.",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/eicad_function03.png"),
              title: "Smart Solutions for Complex Engineering Challenges",
              content: [
                'Delauney continuously explores automation and intelligent design innovations. EICAD’s "Draw Interchange Offset Curves" function automatically generates offset lines and road markings for complex interchanges. Automated longitudinal profile design provides rapid initial grade design solutions. The intelligent multi-level slope template quickly adapts to different terrains, generating 3D slope designs. Compared to conventional methods, EICAD enhances design efficiency by more than 50 times.',
              ],
            },
          ],
        },
        support: {
          title: "EICAD User Support",
          documnentUrl: "/download?type=manual",
          videosUrl: "/academy?type=EICAD",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/eicad_contactbg.png"),
          title: "Get EICAD Now!",
          subTitle:
            "Delauney Digital Design Software Line provides you with a one-stop design solution.",
          firstBtnText: "Download Software",
          firstBtnUrl: "",
          secondBtnText: "Contact Sales Representative",
          secondBtnUrl: "",
        },
        combination: {
          title:
            "Enhance your workflow by integrating EICAD with other software！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/eicad_combination01.png"),
              title: "EICAD + AIRoad + Report3D: ",
              subTitle: "Anyuan Interchange Design & 3D Reporting",
              content:
                "- The project utilized EICAD for route construction drawing design.\n\n- The design information was then imported into AIRoad to generate a 3D road model and integrate it with terrain and oblique models.\n\n- Finally, with one-click import into Report3D, the scene was enhanced for an immersive scheme presentation.",
            },
          ],
          softwares: [
            {
              name: "AIRoad",
              icon: require("@/assets/images/digitalImg/eicad_icon2.png"),
              desc: "Photogrammetry, and remote sensing data. It enables dynamic interactive routing and automated scheme modeling.",
            },
            {
              name: "Report3D",
              icon: require("@/assets/images/digitalImg/report3d_icon4.png"),
              desc: "A reporting tool developed with a game engine, Report3D supports real-time rendering for efficient scene creation and PPT production across various engineering projects.",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "2" }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            let AutoCADTemp = res.data.find(
              (item) => item.name.indexOf("AutoCAD") > -1
            );
            let ZWCADTemp = res.data.find(
              (item) => item.name.indexOf("ZWCAD") > -1
            );
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              AutoCADTemp.pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              AutoCADTemp.pathUrlIdList[0].fileTitle;
            this.businessInfo.banner.downloadBtnList[1].fileUrl =
              ZWCADTemp.pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[1].fileName =
              ZWCADTemp.pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[1].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
            this.businessInfo.banner.downloadBtnList[1].fileName = "";
          }
        }
      });
    },
  },
};
</script>
